import classnames from 'classnames';
import React from 'react';

/**
 * Blueprint's "clean" sparkle with each star as its own path, so consumers
 * can animate them independently.
 */
const STARS = [
  {cx: 6, cy: 10, r: 5.5},
  {cx: 11.5, cy: 4.5, r: 3.5},
  {cx: 13.5, cy: 11.5, r: 2.5},
];

// Four tips at the compass points, sides pulled concave toward the center.
const starPath = ({cx, cy, r}: {cx: number; cy: number; r: number}) =>
  `M ${cx} ${cy - r} Q ${cx} ${cy} ${cx + r} ${cy} Q ${cx} ${cy} ${cx} ${cy + r} ` +
  `Q ${cx} ${cy} ${cx - r} ${cy} Q ${cx} ${cy} ${cx} ${cy - r} Z`;

const STAR_PATHS = STARS.map(starPath);

const SparkleIcon: React.FunctionComponent<
  React.PropsWithChildren<{
    className?: string;
    size?: number;
  }>
> = ({className, size = 16}) => (
  // bp5-icon gives us consistent color / fill handling with Blueprint's built-in icons.
  <span className={classnames('bp5-icon', className)}>
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      {STAR_PATHS.map((d) => (
        <path key={d} d={d} />
      ))}
    </svg>
  </span>
);

export default SparkleIcon;
